import React from 'react';
import { Outlet } from 'react-router-dom';

const AppLayout: React.FC = () => {
  return (
    <div className="relative min-h-screen bg-gray-50 dark:bg-slate-950 flex flex-col">
      <div className="flex-1">
        <Outlet />
      </div>
      {/* Footer */}
      <footer className="mt-8 sm:mt-12 pt-6 sm:pt-8 pb-4 sm:pb-6 px-2 border-t border-gray-200 dark:border-gray-800 text-center text-xs text-gray-500 dark:text-gray-400">
        © 2026 Turing Enterprises Inc. All rights reserved.
      </footer>
    </div>
  );
};

export default AppLayout;

